module.exports = __webpack_public_path__ + "static/gta-b8ac8518af1ec2f850661712c76042d6.png";